import { ChangeDetectorRef, Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { AuthenticationService } from '@core/auth/authentication.service';
import { DialogService } from '@core/services/dialog.service';
import { FormService } from '@core/services/form.service';
import { NotificationService } from '@core/services/notification.service';
// import { UploadService } from '@core/services/upload.service';
import { AppSharedDataService } from 'src/app/app-shared-data.service';

@Injectable({
  providedIn: 'root'
})
export class BaseSharedService {
  constructor(
    public fb: FormBuilder,
    public router: Router,
    public route: ActivatedRoute,
    public dialogService: DialogService,
    public formService: FormService,
    // public uploadService: UploadService,
    public sanitizer: DomSanitizer,
    public location: Location,
    public notificationService: NotificationService,
    public appSharedDataService: AppSharedDataService,
    public authenticationService: AuthenticationService
  ) {
    this.fb = fb;
    this.router = router;
    this.route = route;
    this.dialogService = dialogService;
    this.formService = formService;
    // this.uploadService = uploadService;
    this.sanitizer = sanitizer;
    this.location = location;
    this.notificationService = notificationService;
    this.appSharedDataService = appSharedDataService;
    this.authenticationService = authenticationService;
  }

  getFormBuilder(): FormBuilder {
    return this.fb;
  }

  getRouter(): Router {
    return this.router;
  }

  getRoute(): ActivatedRoute {
    return this.route;
  }

  getDialogService(): DialogService {
    return this.dialogService;
  }

  getFormService(): FormService {
    return this.formService;
  }

  // getUploadService(): UploadService {
  //   return this.uploadService;
  // }

  getSanitizer(): DomSanitizer {
    return this.sanitizer;
  }

  getLocation(): Location {
    return this.location;
  }

  getNotificationService(): NotificationService {
    return this.notificationService;
  }

  getAppSharedDataService(): AppSharedDataService {
    return this.appSharedDataService;
  }

  getAuthenticationService(): AuthenticationService {
    return this.authenticationService;
  }
}
